export default __webpack_public_path__ + "static/media/Petrified-Alien-Blossom.44e5da7d.svg";